export default {"src":"/_next/static/media/ChevronLeftLight.43e72799.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};